import { Dispatch } from 'redux';
import { Services } from '../../types/services';

const FETCH_PRACTICE_ALERTS = 'FETCH_PRACTICE_ALERTS';
const SAVE_PRACTICE_ALERT = 'SAVE_PRACTICE_ALERT';
const SAVE_PRACTICE_ALERT_ERROR = 'SAVE_PRACTICE_ALERT_ERROR';
const DELETE_PRACTICE_ALERT = 'DELETE_PRACTICE_ALERT';
const DELETE_PRACTICE_ALERT_ERROR = 'DELETE_PRACTICE_ALERT_ERROR';
const FETCH_PRACTICE_ALERTS_ERROR = 'FETCH_PRACTICE_ALERTS_ERROR';

interface PracticeAlert {
  id?: string;
  message?: string;
  updatedBy?: string;
  updatedDate?: string;
}

interface State {
  latest: PracticeAlert | null;
  loading: boolean;
  error: string | null;
}

const initialState: State = {
  latest: null,
  loading: false,
  error: null,
};

interface Action {
  type: string;
  payload?: unknown;
}

export const reducer = (state = initialState, action: Action): State => {
  switch (action.type) {
    case FETCH_PRACTICE_ALERTS:
      return { ...state, loading: true, error: null };
    case SAVE_PRACTICE_ALERT:
      return { ...state, latest: action.payload as PracticeAlert, loading: false, error: null };
    case FETCH_PRACTICE_ALERTS_ERROR:
    case SAVE_PRACTICE_ALERT_ERROR:
    case DELETE_PRACTICE_ALERT_ERROR:
      return { ...state, loading: false, error: action.payload as string };
    case DELETE_PRACTICE_ALERT:
      return { ...state, latest: null, loading: false, error: null };
    default:
      return state;
  }
};

export const actions = (services: Services) => {
  const axiosCall = services.axios.Axios();

  const fetchLatestPracticeAlert = (practiceID: string) => {
    return async (dispatch: Dispatch) => {
      try {
        dispatch({ type: FETCH_PRACTICE_ALERTS });
        const response = await axiosCall.get(`/v1/PracticeAlerts/latest/${practiceID}`);
        const data = (response as unknown as { data: PracticeAlert }).data;
        if (data) {
          dispatch({ type: SAVE_PRACTICE_ALERT, payload: data });
        } else {
          dispatch({ type: FETCH_PRACTICE_ALERTS_ERROR, payload: 'No alert found' });
        }
      } catch (error: unknown) {
        dispatch({ type: FETCH_PRACTICE_ALERTS_ERROR, payload: (error as Error).message });
      }
    };
  };

  const savePracticeAlert = (practiceID: string, alertText: string) => {
    return async (dispatch: Dispatch) => {
      try {
        const response = await axiosCall.post(`/v1/PracticeAlerts/${practiceID}`, { message: alertText });
        const data = (response as unknown as { data: PracticeAlert }).data;
        dispatch({
          type: SAVE_PRACTICE_ALERT,
          payload: data || { message: alertText, updatedBy: 'You', updatedDate: new Date().toISOString() },
        });
        return data;
      } catch (error: unknown) {
        dispatch({ type: SAVE_PRACTICE_ALERT_ERROR, payload: (error as Error).message });
      }
    };
  };

  const deletePracticeAlert = (practiceID: string, id: string) => {
    return async (dispatch: Dispatch) => {
      try {
        await axiosCall.patch(`/v1/PracticeAlerts/${practiceID}`, { alertId: id, message: '' });
        dispatch({ type: DELETE_PRACTICE_ALERT });
      } catch (error: unknown) {
        dispatch({ type: DELETE_PRACTICE_ALERT_ERROR, payload: (error as Error).message });
      }
    };
  };

  return {
    deletePracticeAlert,
    fetchLatestPracticeAlert,
    savePracticeAlert,
  };
};

